import { useTranslation } from "react-i18next";
import { Icon, type IconName } from "@/components/ui";

/**
 * Stub page for nav destinations whose features land in later stories (TW-3433 ships the
 * shells + navigation; the screens themselves arrive per module). Renders inside the shell
 * content so nav active-states and routing are demonstrable end to end. The title is an i18n
 * key (TW-3434) so the page heading tracks the language toggle.
 */
export function Placeholder({ titleKey, icon = "sparkle" }: { titleKey: string; icon?: IconName }) {
  const { t } = useTranslation();
  return (
    <div className="page">
      <div className="page-head">
        <h1>{t(titleKey)}</h1>
      </div>
      <div className="empty">
        <div className="empty-ic">
          <Icon name={icon} size={24} />
        </div>
        {t("common.comingSoon")}
      </div>
    </div>
  );
}
